<template>
    <v-dialog
        v-model="vis"
        persistent
        :width="$store.state.blockUIMessages.length ? '420' : '300'"
        content-class="elevation-0"
    >
        <v-alert
            v-for="(msg, i) in $store.state.blockUIMessages"
            :key="i"
            v-model="vis"
            color="warning"
            border="left"
            colored-border
            elevation="2"
        >
            {{ msg }}
            <template v-slot:append>
                <v-btn
                    x-small
                    fab
                    dark
                    depressed
                    color="warning"
                    @click="$store.dispatch('UnblockUI', i)"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </template>
        </v-alert>
        <v-btn
            v-if="$store.state.blockUIMessages.length > 1"
            @click="$store.dispatch('CloseAllBlockUIMessages')"
            rounded
            class="mb-4 mx-auto d-flex"
            width="200"
        >
            {{ $t('Close_All') }}
        </v-btn>
        <v-card
            v-if="$store.state.blockUIMessages.length == 0"
            color="primary"
            dark
        >
            <v-card-text>
                {{ $t('Please_Wait') }}
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'BlockUI',
    data() {
        return {
            vis: true,
        };
    },
};
</script>

<style scoped lang="scss">
</style>
